import React, { useEffect, useState, useContext } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import {
  useTransition,
  animated,
  config as springConfig
} from '@react-spring/web'
import { CopyToClipboardUrl } from 'components/copyToClipboardUrl'
import { ArticleTeaser } from 'components/articleLink'
import { VideoAuto } from 'components/videoAuto'
import stylesSheet from './infoLayer.m.scss'
// import VideoPlayerContext from '../videoPlayerContext'
import { VideoPlayerProvider } from '../videoPlayerContext'

const isMobile = window.innerWidth < 768
const randomArticles = [
  861373316366,
  898870841121,
  378340152181,
  339494938235,
  568086529447,
  775895217110,
  949517109675,
  588148085500
]

const randomChosenArticles = (num: number) => {
  const chosenArticles = []
  const articles = [...randomArticles]

  for (let i = 0; i < num; i++) {
    const randomIndex = Math.floor(Math.random() * articles.length)
    chosenArticles.push(articles[randomIndex])
    articles.splice(randomIndex, 1)
  }

  return chosenArticles
}

export const InfoLayer = ({ candidates }: { candidates: Candidat[] }) => {
  const location = useLocation()
  const history = useHistory()

  const [selectedCandidate, setSelectedCandidate] = useState()
  const [showInfoLayer, setShowInfoLayer] = useState(false)
  const [muted, setMuted] = useState(true)

  const handleExit = () => {
    history.replace('/')
  }

  const transitions = useTransition(showInfoLayer, {
    config: springConfig.stiff,
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    onRest: () => {
      if (location.pathname === '/') {
        document.body.classList.remove('freeze')
      } else {
        document.body.classList.add('freeze')
      }
    }
  })

  useEffect(() => {
    if (candidates) {
      const candidate = candidates
        ? candidates.find(c => c.id === location.pathname.substr(1))
        : null

      if (location.pathname === '/') {
        setShowInfoLayer(false)
      } else {
        setSelectedCandidate(candidate)
      }

      if (candidate) {
        setShowInfoLayer(true)
      }
    }
  }, [location.pathname, candidates])

  const nextCandidate = selectedCandidate
    ? candidates[
        (candidates.findIndex(c => c.id === selectedCandidate.id) + 1) %
          candidates.length
      ]
    : null

  return transitions(
    (styles, item) =>
      item && (
        <>
          <animated.div
            className={stylesSheet.dimmer}
            onClick={() => {
              handleExit()
            }}
            style={styles}
          />
          {/* <animated.div
            className={stylesSheet.closeBtn}
            style={{ opacity: styles.opacity.to([0.5, 1], [0, 1]) }}
            onClick={() => {
              handleExit()
            }}
          >
            <div className='close' />
          </animated.div> */}
          <animated.div
            className={stylesSheet.infoLayer}
            style={{
              transform: styles.opacity.to(
                v => 'translate3d(0,' + (1 - v) * 100 + '%,0)'
              )
            }}
          >
            <div className={stylesSheet.videoContainer}>
              {selectedCandidate && (
                <div className={stylesSheet.menu}>
                  <img
                    onClick={() => {
                      history.replace(`${nextCandidate.id}`)
                    }}
                    className={stylesSheet.nextCandidatePicture}
                    src={require(`../candidats-cards/candidats-pictures/${nextCandidate.id}.jpg`)}
                  />
                  <div
                    className={stylesSheet.menuInfos}
                    onClick={() => {
                      history.replace(`${nextCandidate.id}`)
                    }}
                  >
                    <div>
                      {nextCandidate.genre === 'f'
                        ? 'Candidate suivante'
                        : 'Candidat suivant'}
                    </div>
                    <div className={stylesSheet.menuName}>
                      {nextCandidate.nom}
                    </div>
                    <div className={stylesSheet.link}>
                      Voir la vidéo{' '}
                      <i
                        style={{ fontSize: '0.65em' }}
                        className='ui icon chevron right'
                      />
                    </div>
                  </div>
                  <div
                    onClick={() => {
                      handleExit()
                    }}
                    className={stylesSheet.closeBtnMenu}
                  >
                    <div className={stylesSheet.close} />
                  </div>
                </div>
              )}
              <VideoPlayerProvider value={{ muted, setMuted }}>
                <VideoAuto
                  src={require(`../../videos/${selectedCandidate.id}.mp4`)}
                />
              </VideoPlayerProvider>
            </div>

            <div className='ui vertical fitted segment info-footer'>
              <div
                className='ui ta inverted text special container'
                style={{ fontFamily: 'TamediaChart' }}
              >
                {selectedCandidate && (
                  <div>
                    <div className={stylesSheet.name}>
                      {selectedCandidate.nom}
                    </div>
                    <div className={stylesSheet.infos}>
                      <div>
                        {selectedCandidate.naissance} ans,{' '}
                        {selectedCandidate.residence}
                      </div>
                      <div>{selectedCandidate.groupe.nom}</div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div
              style={{
                borderTop: '1px solid #ffffff33',
                borderBottom: '1px solid #ffffff33'
              }}
              className='ui text container'
            >
              <div className='ui vertical fitted segment'>
                <CopyToClipboardUrl
                  inverted
                  locale='fr'
                  title='Partager ce contenu'
                  text='Partagez cette vidéo avec vos amis et vos connaissances!'
                  url={window.location.href}
                  buttonColor='#539ea4'
                />
              </div>
            </div>
            {selectedCandidate && selectedCandidate.articles.length > 0 && (
              <div className='ui vertical fitted segment info-footer'>
                <div className='ui ta inverted text container'>
                  <ArticleTeaser
                    title='À lire aussi'
                    color='#539ea4'
                    ids={[
                      ...randomChosenArticles(3),
                      ...selectedCandidate.articles
                    ]}
                  />
                </div>
              </div>
            )}
          </animated.div>
        </>
      )
  )
}
